import { CSSProperties } from 'react';

import { FontAwesomeIcon } from './FontAwesomeIcon';

export const InteractiveHeartIcon = ({
  isLiked,
  className,
  style,
}: {
  isLiked: boolean;
  className?: string;
  style?: CSSProperties;
}) => {
  const iconStyle = {
    color: isLiked ? '#e91e63' : undefined,
    ...style,
  };

  return (
    <FontAwesomeIcon
      className={className}
      name={isLiked ? 'heart' : 'heart-outline'}
      style={iconStyle}
    />
  );
};
